import { IApplicationState } from '../../../types/redux';

export const selectRequestLocationId = (state: IApplicationState) => state.location.requestLocationId;
